import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

momentDurationFormatSetup(moment);

export const monthFormat = 'MMM YYYY';
export const dateFormat = 'DD.MM.YYYY';
export const isoDateFormat = 'YYYY-MM-DD';
export const datetimeFormat = 'DD.MM.YYYY, HH:mm';
export const detailedDatetimeFormat = 'DD.MM.YYYY, HH:mm:ss';
export const timeFormat = 'HH:mm';
export const detailedTimeFormat = 'HH:mm:ss';
export const daysDurationFormat = 'DD[d] HH[h]';
export const durationFormat = 'HH[h] mm[m]';
export const minutesDurationFormat = 'mm[m] ss[s]';
export const secondsDurationFormat = 'ss[s] SSS[ms]';
export const durationFormatWithDays = 'd[d] HH[h] mm[m]';
export const detailedDurationFormat = 'HH[h] mm[m] ss[s]';
export const messageValidTimeFormat = 'Do MMMM YYYY, HH:mm';

export const toISODate = (date) => date.toISOString(true).split('T')[0];

export const daysInFuture = (date) => moment().diff(moment(date), 'days') * -1;

moment.locale('en');
moment.defaultFormat = datetimeFormat;
